export default {
  Titulo: 'Endereço',
  Campos: {
    Cep: {
      Tipo: 'mask',
      Label: 'CEP',
      Tooltip: 'CEP',
      Placeholder: 'CEP',
      Mascara: 'CEP',
      Obrigatorio: true,
    },
    EnderecoLookup: {
      Tipo: 'lookup',
      Tooltip: 'Pesquisa de Endereço',
    },
    UF: {
      Tipo: 'combobox',
      Label: 'UF',
      Tooltip: 'UF',
      Placeholder: 'UF',
      Obrigatorio: true,
      Desabilitado: true,
      itens: [
        { Texto: 'Acre', Valor: 'AC' },
        { Texto: 'Alagoas', Valor: 'AL' },
        { Texto: 'Amapá', Valor: 'AP' },
        { Texto: 'Amazonas', Valor: 'AM' },
        { Texto: 'Bahia', Valor: 'BA' },
        { Texto: 'Ceará', Valor: 'CE' },
        { Texto: 'Distrito Federal', Valor: 'DF' },
        { Texto: 'Espírito Santo', Valor: 'ES' },
        { Texto: 'Goiás', Valor: 'GO' },
        { Texto: 'Maranhão', Valor: 'MA' },
        { Texto: 'Mato Grosso', Valor: 'MT' },
        { Texto: 'Mato Grosso do Sul', Valor: 'MS' },
        { Texto: 'Minas Gerais', Valor: 'MG' },
        { Texto: 'Pará', Valor: 'PA' },
        { Texto: 'Paraíba', Valor: 'PB' },
        { Texto: 'Paraná', Valor: 'PR' },
        { Texto: 'Pernambuco', Valor: 'PE' },
        { Texto: 'Piauí', Valor: 'PI' },
        { Texto: 'Rio de Janeiro', Valor: 'RJ' },
        { Texto: 'Rio Grande do Norte', Valor: 'RN' },
        { Texto: 'Rio Grande do Sul', Valor: 'RS' },
        { Texto: 'Rondônia', Valor: 'RO' },
        { Texto: 'Roraima', Valor: 'RR' },
        { Texto: 'São Paulo', Valor: 'SP' },
        { Texto: 'Sergipe', Valor: 'SE' },
        { Texto: 'Santa Catarina', Valor: 'SC' },
        { Texto: 'Tocantins', Valor: 'TO' },
      ],
    },
    Cidade: {
      Tipo: 'text',
      Label: 'Cidade',
      Tooltip: 'Cidade',
      Placeholder: 'Cidade',
      Obrigatorio: true,
      Desabilitado: true,
      Tamanho: 50,
    },
    Tipo: {
      Tipo: 'typeahead',
      Label: 'Tipo',
      Tooltip: 'Tipo',
      Placeholder: 'Tipo',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Logradouro: {
      Tipo: 'text',
      Label: 'Logradouro',
      Tooltip: 'Logradouro',
      Placeholder: 'Logradouro',
      Obrigatorio: true,
      Desabilitado: true,
      Tamanho: 60,
    },
    Bairro: {
      Tipo: 'text',
      Label: 'Bairro',
      Tooltip: 'Bairro',
      Placeholder: 'Bairro',
      Obrigatorio: true,
      Desabilitado: true,
      Tamanho: 60,
    },
    Numero: {
      Tipo: 'number',
      Label: 'Número',
      Tooltip: 'Número',
      Placeholder: 'Número',
      Tamanho: 9,
    },
    Complemento: {
      Tipo: 'text',
      Label: 'Complemento',
      Tooltip: 'Complemento',
      Placeholder: 'Complemento',
      Tamanho: 60,
    },
    ComplementoNumero: {
      Tipo: 'text',
      Label: 'Complemento Número',
      Tooltip: 'Complemento Número',
      Placeholder: 'Complemento Número',
      Tamanho: 10,
    },
    FiltrarEndereco: {
      Tipo: 'radio',
      Label: 'Filtrar por',
      Itens: [
        {
          Texto: 'Cep Correios',
          Valor: 1,
          Tooltip: 'Cep Correios',
          Tamanho: 6,
          Checked: true,
        },
        {
          Texto: 'Cep Interno',
          Valor: 2,
          Tooltip: 'Cep Interno',
          Tamanho: 6,
        },
      ],
    },
  },
};
